export default {
  formValidation: {
    emptyField: 'Câmpul nu poate fi gol',
    requiredField: 'Câmpul este obligatoriu',
    passwordToShort: 'Parola trebuie să aibă 8 caractere',
    emailNotValid: 'Câmpul trebuie să conțină o adresă de e-mail validă',
    emailReserved: 'Adresa de e-mail este deja ocupată',
    rateEmpty: 'Toate câmpurile trebuie completate',
    serverUnknownError: 'Eroare de comunicare cu serverul',
    invalidCharacters: 'Câmpul conține caractere invalide',
    phoneNotValid: 'Numărul de telefon este incorect',
    checkBoxBelow: 'Please tick the box below to send a message',
  },
  password: {
    show: 'arată',
    hide: 'ascunde',
  },
  howItWorks: {
    showButton: 'Arată mai mult',
    hideButton: 'Arată mai puțin',
  },
}
